import React, { useState, useEffect } from "react";
import "../App.css";

import Axios from "axios";
import { useParams, useNavigate } from "react-router-dom";

import { MDBInput, MDBSwitch, MDBBtn } from "mdb-react-ui-kit";

import { registerLocale } from "react-datepicker";
import 'react-datepicker/dist/react-datepicker.css'
import de from "date-fns/locale/de";
import Moment from 'moment';
import {
    backendPathAccounting,
} from "../Constants";
import {checkWritePermission} from "../functions/permissions";
import TopNavbar from "../components/Navbar";


registerLocale("de", de);
Moment.locale('de');


function EditCustomerInvoice() {
    const { id } = useParams();
    const navigate = useNavigate();

    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [firstNameInvoice, setFirstNameInvoice] = useState("");
    const [lastNameInvoice, setLastNameInvoice] = useState("");
    const [streetInvoice, setStreetInvoice] = useState("");
    const [houseNumberInvoice, setHouseNumberInvoice] = useState("");
    const [zipInvoice, setZIPInvoice] = useState("");
    const [cityInvoice, setCityInvoice] = useState("");
    const [sepa, setSepa] = useState(false);
    const [basicPrice, setBasicPrice] = useState(0);

    const [submitted, setSubmitted] = useState(false);

    const [writePermission, setWritePermission] = useState(false);
    const [readPermission, setReadPermission] = useState(false);


    const getCustomerInvoice = () => {
        Axios.get(`${backendPathAccounting}customer-invoice.php?id=${id}`).then((response) => {
            const customer = response.data[0];
            console.log(customer);
            setFirstName(customer["FirstName"]);
            setLastName(customer["LastName"]);
            if (customer["FirstNameInvoice"]) {
                setFirstNameInvoice(customer["FirstNameInvoice"]);
            }
            if (customer["LastNameInvoice"]) {
                setLastNameInvoice(customer["LastNameInvoice"]);
            }
            if (customer["StreetInvoice"]) {
                setStreetInvoice(customer["StreetInvoice"]);
            }
            if (customer["HouseNumberInvoice"]) {
                setHouseNumberInvoice(customer["HouseNumberInvoice"]);
            }
            if (customer["ZIPInvoice"]) {
                setZIPInvoice(customer["ZIPInvoice"]);
            }
            if (customer["CityInvoice"]) {
                setCityInvoice(customer["CityInvoice"]);
            }
            if (customer["SEPA"]) {
                setSepa(customer["SEPA"]);
            }
            if (customer["BasicPrice"]) {
                setBasicPrice(customer["BasicPrice"]);
            }
        });
    };

    const checkValidity = () => {
        console.log(zipInvoice);
        return zipInvoice === "" || zipInvoice.toString().length === 5;
    };

    const updateCustomerInvoice = () => {
        setSubmitted(true);

        if (!checkValidity()) {
            return;
        }

        Axios.get(backendPathAccounting+"update-customer-invoice.php", {
            params: {
                id: id,
                firstNameInvoice: firstNameInvoice,
                lastNameInvoice: lastNameInvoice,
                streetInvoice: streetInvoice,
                houseNumberInvoice: houseNumberInvoice,
                zipInvoice: zipInvoice,
                cityInvoice: cityInvoice,
                sepa: Number(sepa),
                basicPrice: basicPrice,
            }
        }).then(() => {
            navigate("/invoices");
        });
        
    };

    useEffect(() => {
        checkWritePermission(navigate, setReadPermission, setWritePermission);
    }, []);

    useEffect(() => {
        getCustomerInvoice();
        console.log("customer id ", id);
    }, [id]);

    return (
        <div>
            <TopNavbar readPermissionInitial={readPermission} writePermissionInitial={writePermission}/>
            <div className="main">
                <div className="header">
                    <h2>Rechnungsdaten von {firstName} {lastName} bearbeiten</h2>
                </div>

                <div className='input-form'>
                    <MDBInput className="input" label='Vorname Rechnungsempfänger' type='text' value={firstNameInvoice}
                              onChange={(event) => {
                                  setFirstNameInvoice(event.target.value);
                              }}/>

                    <MDBInput className="input" label='Nachname Rechnungsempfänger' type='text' value={lastNameInvoice}
                              onChange={(event) => {
                                  setLastNameInvoice(event.target.value);
                              }}/>

                    <MDBInput className="input col-md-6" label='Straße Rechnungsempfänger' type='text'
                              value={streetInvoice}
                              onChange={(event) => {
                                  setStreetInvoice(event.target.value);
                              }}/>

                    <MDBInput className="input col-md-6" label='Hausnummer Rechnungsempfänger' type='text'
                              value={houseNumberInvoice}
                              onChange={(event) => {
                                  setHouseNumberInvoice(event.target.value);
                              }}/>

                    <MDBInput className="input col-md-6" label='Postleitzahl Rechnungsempfänger' id='form2'
                              type='text' value={zipInvoice}
                              onChange={(event) => {
                                  setZIPInvoice(event.target.value);
                              }}/>
                    {(submitted && zipInvoice && zipInvoice.toString().length !== 5) ?
                        <p className="validation-label">Postleitzahl ist nicht gültig.</p> : null
                    }

                    <MDBInput className="input col-md-6" label='Stadt Rechnungsempfänger' id='form2' type='text'
                              value={cityInvoice}
                              onChange={(event) => {
                                  setCityInvoice(event.target.value);
                              }}/>

                    <p className="input-label">SEPA-Mandat</p>
                    <div className="input">
                        <MDBSwitch label={sepa ? "erteilt" : "nicht erteilt"}
                                   checked={sepa}
                                   onChange={(event) => setSepa(s => (s + 1) % 2)}/>
                    </div>

                    <MDBInput className="input col-md-6" label='monatlicher Grundpreis' id='form2' type='number' value={basicPrice}
                              onChange={(event) => {
                                  setBasicPrice(Number(event.target.value));
                              }}/>
                </div>

                <div className="footer">
                    <MDBBtn className="btn" type="submit" onClick={updateCustomerInvoice}>Speichern</MDBBtn>
                </div>

            </div>
        </div>
    );
}

export default EditCustomerInvoice;